<template>
  <div class="doudian-video-preview">
    <button v-if="available" type="button" :disabled="loading" @click="open">
      <img v-if="coverUrl" :src="coverUrl" alt="视频封面" @error="coverFailed = true" v-show="!coverFailed" />
      <i class="el-icon-video-play" aria-hidden="true"></i>
      <span>{{ loading ? '加载中' : label || '播放视频' }}</span>
    </button>
    <span v-else>{{ label || '无视频' }}</span>
    <el-dialog title="视频预览" :visible.sync="visible" :z-index="4000" width="min(720px, 92vw)" append-to-body @close="stop">
      <video
        v-if="visible && url"
        ref="player"
        :src="url"
        controls
        autoplay
        class="video-player"
        @error="failed" />
    </el-dialog>
  </div>
</template>

<script>
import { getDoudianMainVideoPlayInfo } from '@/api/main/doudianBatchEdit'

export default {
  name: 'DoudianVideoPreview',
  props: {
    requestData: { type: Object, default: null },
    coverUrl: String,
    label: String,
    available: Boolean
  },
  data: () => ({ loading: false, visible: false, url: '', sequence: 0, coverFailed: false }),
  watch: {
    requestData: {
      deep: true,
      handler() {
        this.sequence++
        this.loading = false
        this.stop()
      }
    },
    coverUrl() {
      this.coverFailed = false
    }
  },
  beforeDestroy() {
    this.sequence++
    this.stop()
  },
  methods: {
    async open() {
      if (!this.requestData || this.loading) return
      const seq = ++this.sequence
      this.loading = true
      try {
        const res = await getDoudianMainVideoPlayInfo(this.requestData)
        if (seq !== this.sequence || this._isDestroyed) return
        if (!res.data?.play_url) throw new Error('未取得视频播放地址')
        this.url = res.data.play_url
        this.visible = true
      } catch (error) {
        if (seq === this.sequence) this.$message.error(error.message || '视频加载失败')
      } finally {
        if (seq === this.sequence) this.loading = false
      }
    },
    stop() {
      if (this.$refs.player) this.$refs.player.pause()
      this.url = ''
      this.visible = false
    },
    failed() {
      this.$message.error('视频播放地址已失效或暂时无法加载，请重新播放')
      this.stop()
    }
  }
}
</script>

<style scoped>
.doudian-video-preview button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border: 1px solid #dce3ef;
  border-radius: 6px;
  background: #fff;
  color: #1677ff;
  cursor: pointer;
}
.doudian-video-preview img {
  width: 52px;
  height: 52px;
  object-fit: cover;
}
.doudian-video-preview span {
  max-width: 180px;
  overflow-wrap: anywhere;
}
.video-player {
  width: 100%;
  max-height: 65vh;
}
</style>
